"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Salutation = void 0;

var Salutation =
/** @class */
function () {
  function Salutation() {}

  Salutation.prototype.SalutationLocaleType = function () {
    return [{
      slug: 'english',
      name: 'English',
      description: null,
      isEnglish: true,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'german',
      name: 'German',
      description: null,
      isEnglish: false,
      isGerman: true,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'french',
      name: 'French',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: true,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'hebrew',
      name: 'Hebrew',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: true,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'polish',
      name: 'Polish',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: true,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'portuguese',
      name: 'Portuguese',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: true,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'spanish',
      name: 'Spanish',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: true,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'spanish-south-america',
      name: 'Spanish (South America)',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: true,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'thai',
      name: 'Thai',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: true,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'italian',
      name: 'Italian',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: true,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'chinese-traditional',
      name: 'Chinese (Tradition)',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: true,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'chinese-mandarin',
      name: 'Chinese (Mandarin)',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: true,
      isJapanese: false,
      isKorean: false
    }, {
      slug: 'japanese',
      name: 'Japanese',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: true,
      isKorean: false
    }, {
      slug: 'korean',
      name: 'Korean',
      description: null,
      isEnglish: false,
      isGerman: false,
      isFrench: false,
      isHebrew: false,
      isPolish: false,
      isPortuguese: false,
      isSpanish: false,
      isSpanishSouthAmerica: false,
      isThai: false,
      isItalian: false,
      isChineseTraditional: false,
      isChineseMandarin: false,
      isJapanese: false,
      isKorean: true
    }];
  };

  return Salutation;
}();

exports.Salutation = Salutation;